import { tokens } from './tokens';

export const theme = {
  tokens,
  colors: tokens.color,
};

export { tokens };
